var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMore = function SvgMore(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon--more",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.05357 6.33333C8.68475 6.33333 9.19643 6.85567 9.19643 7.5C9.19643 8.14433 8.68475 8.66667 8.05357 8.66667C7.42239 8.66667 6.91071 8.14433 6.91071 7.5C6.91071 6.85567 7.42239 6.33333 8.05357 6.33333Z",
    stroke: "#232735",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1964 4L8.05357 4C6.16002 4 4.625 5.567 4.625 7.5C4.625 9.433 6.16002 11 8.05357 11L17.1964 11C19.09 11 20.625 9.433 20.625 7.5C20.625 5.567 19.09 4 17.1964 4Z",
    stroke: "#232735",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.625 17C21.625 19.2091 19.7446 21 17.425 21H7.825C5.5054 21 3.625 19.2091 3.625 17C3.625 14.7909 5.5054 13 7.825 13L17.425 13C19.7446 13 21.625 14.7909 21.625 17ZM17.425 18.7143C16.4309 18.7143 15.625 17.9468 15.625 17C15.625 16.0532 16.4309 15.2857 17.425 15.2857C18.4191 15.2857 19.225 16.0532 19.225 17C19.225 17.9468 18.4191 18.7143 17.425 18.7143Z",
    fill: "#232735"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMore);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "more.3b702fd4107c76638d25a3abeb71e1d6.svg";